export default "__VITE_PUBLIC_ASSET__e7a6beb1__"